import WishlistTab from "../../components/planning/WishlistTab";

export default function PlanWishlist() {
  return (
    <main className="max-w-6xl mx-auto px-6 md:px-12 pt-8 md:pt-10 pb-28 md:pb-10" data-testid="plan-wishlist-page">
      <WishlistTab />
    </main>
  );
}
